import React, { useEffect, useState } from "react";
import "../styles/blogdetail.scss";
import Headertop from "../components/Headertop";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";

const Blogdetail = () => {
  const [data, setData] = useState(null); // keep null instead of []
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const getDataById = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `https://tomcat.diwise.in/HCCBlogsandContact/blog/getBybId?bId=${id}`
      );
      setData(res.data.data); // API response has {status, responsemessage, data}
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataById();
  }, [id]);



  const dateObject = new Date(data?.date);
  const year = dateObject.getFullYear();
  const month = dateObject.getMonth() + 1;
  const day = dateObject.getDate();
  const formattedDate = `${day < 10 ? "0" + day : day}/${
    month < 10 ? "0" + month : month
  }/${year}`;

  return (
    <>
      <Headertop title="Our Blogs" />
      {loading && <Loader parent={true} />}
      <div className="blog_detail_parent parent">
        <div className="blog_detail_container container">
          <div
            className="blog_detail_top"
            style={{ background: `url(${data?.featuredImage})` }}
          ></div>
          <div className="blog_detail_bottom">
            <div className="bottom_details">
              <div className="date btn-dark-cream">{formattedDate}</div>
              <div className="date btn-dark-cream">{data?.category}</div>
            </div>
            <div className="blog_detail_heading">
              <h1>{data?.title}</h1>
            </div>
            <div
              className="blog_detail_content"
              dangerouslySetInnerHTML={{ __html: data?.description }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogdetail;
